var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Slider
 */

var clip = function clip(v, min, max) {
  if (v < min) {
    return min;
  }
  if (v > max) {
    return max;
  }
  return v;
};

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.getSteppedValue = function (value) {
      if (_this.props.step) {
        var steps = (value - _this.state.prevValue) / _this.props.step;
        if (Math.round(steps)) {
          return _this.state.prevValue + Math.round(steps) * _this.props.step;
        }
      } else {
        return value;
      }
    };

    _this.updateMoveValue = function (value) {
      var newValue = _this.getSteppedValue(value);
      if (newValue !== undefined && newValue !== _this.state.prevValue) {
        _this.setState({ value: newValue, prevValue: newValue });
        if (_this.props.onMove) {
          _this.props.onMove(newValue);
        }
      }
    };

    _this.setValue = function (value) {
      this.setState({ value: value, prevValue: value });
      if (this.props.onChange) {
        this.props.onChange(value);
      }
      if (this.props.onMove) {
        this.props.onMove(value);
      }
    };

    _this.onChange = function (event) {
      var value = parseFloat(event.target.value, 10);
      _this.setValue(clip(value, _this.props.min, _this.props.max));
    };

    _this.onMouseUp = function (event) {
      _this.setState({
        mouseDown: false
      });
      document.removeEventListener('mousemove', _this.onMouseMove);
      document.removeEventListener('touchmove', _this.onMouseMove);
      document.removeEventListener('mouseup', _this.onMouseUp);
      document.removeEventListener('touchend', _this.onMouseUp);
      if (_this.props.onChange) {
        _this.props.onChange(_this.state.value);
      }
    };

    _this.getValueFromSlider = function (event) {
      // const {slider} = this.refs
      var pageX = event.pageX || event.touches[0].pageX;
      var x = pageX - 8 - _this.c.getBoundingClientRect().left;
      return clip(x / _this.state.ratio + _this.props.min, _this.props.min, _this.props.max);
    };

    _this.onMouseDown = function (event) {
      event.preventDefault();
      _this.setState({
        mouseDown: true
      });
      document.addEventListener('mousemove', _this.onMouseMove);
      document.addEventListener('touchmove', _this.onMouseMove);
      document.addEventListener('mouseup', _this.onMouseUp);
      document.addEventListener('touchend', _this.onMouseUp);
    };

    _this.onMouseMove = function (event) {
      if (_this.state.mouseDown) {
        var value = _this.getValueFromSlider(event);
        _this.updateMoveValue(value);
      }
    };

    _this.onClick = function (event) {
      var value = _this.getValueFromSlider(event);
      var steppedValue = _this.getSteppedValue(value);
      if (steppedValue !== undefined) {
        _this.setValue(steppedValue);
      }
    };

    _this.state = {
      mouseDown: false,
      isAnimating: false,
      value: props.value || 0,
      prevValue: props.value || 0,
      step: 1,
      // ratio between actual dom element width and range value (min -> max)
      ratio: 1
    };
    return _this;
  }

  _createClass(Slider, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== undefined) {
        this.setState({ value: nextProps.value, prevValue: nextProps.value });
      }
    }

    // get initial width of dom element

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // const {slider} = this.refs
      var width = this.c.getBoundingClientRect().width - 16;
      this.setState({
        ratio: width / (this.props.max - this.props.min)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var position = (this.state.value - this.props.min) * this.state.ratio;

      return React.createElement(
        'label',
        { className: 'mdc-Slider' },
        React.createElement('input', {
          className: 'mdc-Slider-input',
          max: this.props.max,
          min: this.props.min,
          onChange: this.onChange,
          type: 'range',
          value: this.state.value,
          step: this.props.step
        }),
        React.createElement(
          'div',
          {
            className: 'mdc-Slider-track',
            onMouseDown: this.onMouseDown,
            onTouchStart: this.onMouseDown,
            onMouseMove: this.onMouseMove,
            onTouchMove: this.onMouseMove,
            onClick: this.onClick,
            ref: function ref(c) {
              _this2.c = c;
            }
          },
          React.createElement(
            'div',
            { className: 'mdc-Slider-track-off' },
            React.createElement('div', { className: 'mdc-Slider-track-on', style: { width: position + 'px' } })
          ),
          React.createElement('div', {
            className: 'mdc-Slider-thumb' + (this.state.value === this.props.min ? ' is-zero' : ''),
            style: { left: position + 'px' }
          })
        )
      );
    }
  }]);

  return Slider;
}(React.Component);

export default Slider;


Slider.propTypes = {
  value: PropTypes.number,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number,
  onChange: PropTypes.func,
  onMove: PropTypes.func
};

Slider.defaultProps = {
  value: 0
};


//////////////////
// WEBPACK FOOTER
// ../es/js/slider/index.js
// module id = 294
// module chunks = 0